import { lazy } from 'react';

const CertifiedNomineesIntegrativePageConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/certificates/integrative/nominees',
			component: lazy(() => import('./CertifiedNomineesPage'))
		}
	]
};

export default CertifiedNomineesIntegrativePageConfig;